import { Location } from 'types';

export const serializeLocation = (residence: Location) => {
  const { name, lat, lng } = residence;
  return { name, latitude: lat, longitude: lng };
};
